import React from 'react';

import styled from 'styled-components';

import { getMoment } from '@libs/NwMoment';
import { isAllDay, showDateNoTime } from '@libs/NwMoment';

import { getContactName } from '@hooks/API/Contact/UseContactsList';
import useEventStyle from '@hooks/CachedLists/UseEventStyle';

import AddressLine from '@components/Addresses/AddressLine';
import FlexContainer from '@components/Gui/FlexContainer';
import NwIcon from '@components/Gui/NwIcon';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const EventFieldsTable = styled.table`
    width: 100%;
    tr {
        display: flex;
    }
    td {
        display: flex;
        flex-direction: column;
        flex: 1;
        border-right: ${(props) => props.theme.DefaultBorder};
        padding: 0 1rem;
        text-transform: uppercase;
        font-size: 0.8rem;

        .icon-container {
            padding-right: 1rem;
            svg {
                font-size: 2.4rem;
                margin: 0 0 8px;
            }
        }
        .address-container {
            cursor: pointer;
            margin-bottom: 1rem;
        }
        .arrow-dropdown {
            font-size: 0.95rem;
            margin: 4px 0;
        }
        .label {
            font-size: 0.65rem;
        }
        .date {
            font-size: 0.8rem;
            font-weight: bold;
        }

        &:first-child {
            padding-left: 0;
            flex: unset;
        }
        &:last-child {
            border-right: none;
        }
    }
`;

const ScoutingMeetingDetails = ({ scoutingMeetingsData }) => {
    const meetingStyle = useEventStyle({}, 'Meeting');

    return (
        <FlexContainer pd="16px 30px 16px 40px">
            <EventFieldsTable>
                <tbody>
                    <tr>
                        <td>
                            <div className="icon-container">
                                <NwIcon icon={meetingStyle.icon} />
                            </div>
                        </td>
                        <td>
                            <div className="address-container">
                                <AddressLine address={scoutingMeetingsData} twoLines noIcon />
                            </div>
                            <div>{getContactName(scoutingMeetingsData.ContactID)}</div>
                        </td>
                        <td>
                            <FlexContainer column alignItems="flex-start" justifyContent="center">
                                <div>{showDateNoTime(scoutingMeetingsData.StartDate)}</div>
                                {isAllDay(scoutingMeetingsData.StartDate, scoutingMeetingsData.EndDate) ? (
                                    <div className="date">All Day</div>
                                ) : (
                                    <>
                                        <FlexContainer column justifyContent="center" alignItems="center">
                                            <div className="date">
                                                {getMoment(scoutingMeetingsData.StartDate).format('HH:mm')}
                                            </div>
                                            <NwIcon
                                                icon={byPrefixAndName.fasl['arrow-down']}
                                                className="arrow-dropdown"
                                            />
                                        </FlexContainer>
                                        <div className="date">
                                            {getMoment(scoutingMeetingsData.EndDate).format('HH:mm')}
                                        </div>
                                    </>
                                )}
                            </FlexContainer>
                        </td>
                    </tr>
                </tbody>
            </EventFieldsTable>
        </FlexContainer>
    );
};

export default ScoutingMeetingDetails;
